import React from "react"
import { Progress } from "@carrotfertility/carotene-core"
import { useIsSprintsVisible } from "#/services/user/hooks/useSprintsQuery"
import SprintIntroPage from "./page"
import { SprintsUnauthorizedPage } from "./SprintsUnauthorizedPage"

export function SprintsLandingPageRoute(): JSX.Element {
  const { isVisible: shouldShowSprintsPage, isLoading } = useIsSprintsVisible()

  if (isLoading) {
    return <Progress />
  }

  if (!shouldShowSprintsPage) {
    return <SprintsUnauthorizedPage />
  }

  return <SprintIntroPage />
}
